export enum HandoutBizTypeEnum {
  Class = 'class',
  Course = 'course',
  Task = 'task',
}
